import { useContext } from 'react'

import { LiveOrdersContext } from '@/contexts/live-orders-context'

const useLiveOrders = () => {
  return useContext(LiveOrdersContext)
}

export default useLiveOrders
